export default function buildMatchFn(args) {
    return (string, options = {}) => {
        const width = options.width;
        const matchPattern = (width && args.matchPatterns[width]) ||
            args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) {
            return null;
        }
        const matchedString = matchResult[0];
        const parsePatterns = (width && args.parsePatterns[width]) ||
            args.parsePatterns[args.defaultParseWidth];
        const key = (Array.isArray(parsePatterns)
            ? findIndex(parsePatterns, (pattern) => pattern.test(matchedString))
            : findKey(parsePatterns, (pattern) => pattern.test(matchedString)));
        let value;
        value = (args.valueCallback ? args.valueCallback(key) : key);
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return { value, rest };
    };
}
// eslint-disable-next-line no-unused-vars
function findKey(object, predicate) {
    for (const key in object) {
        // @ts-ignore
        // eslint-disable-next-line no-prototype-builtins
        if (object.hasOwnProperty(key) && predicate(object[key])) {
            return key;
        }
    }
    return undefined;
}
function findIndex(array, predicate) {
    for (let key = 0; key < array.length; key++) {
        if (predicate(array[key])) {
            return key;
        }
    }
    return undefined;
}
